import DetailChoiceFeat from './DetailChoiceFeat';

export default DetailChoiceFeat;
export { DetailChoiceFeat };
